// extracted by mini-css-extract-plugin
export default {"container":"CoinContainer_container__nXYW7","clearButton":"CoinContainer_clearButton__ldQdz"};